module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_1000000.729f8333.png";